module.exports = "<svg width=\"26\" height=\"26\" viewBox=\"0 0 26 26\" xmlns=\"http://www.w3.org/2000/svg\">\n  <title>\n    Artboard 3\n  </title>\n  <path d=\"M23.667 1H2.334C1.597 1 1 1.597 1 2.333v21.334C1 24.403 1.597 25 2.334 25H13.82v-9.28h-3.116v-3.634h3.116V9.42c0-3.1 1.894-4.79 4.667-4.79.933-.003 1.866.045 2.793.143V8h-1.913c-1.503 0-1.797.716-1.797 1.767v2.313h3.597l-.467 3.633h-3.13V25h6.097c.736 0 1.333-.597 1.333-1.333V2.333C25 1.597 24.403 1 23.667 1\" fill=\"#15100C\" fill-rule=\"evenodd\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./assets/svg/icon-26-facebook.svg
// module id = 3709
// module chunks = 168707334958949